import { lazy, Suspense } from 'react'
import styled, { CSSProperties } from 'styled-components'
import { useTranslation } from 'react-i18next'

import { Text, Box, Spinner } from 'components'

const NoResultImg = lazy(() => import('assets/documents-empty-state.svg'))
const NoResultSearchImg = lazy(() => import('assets/table-no-result.svg'))

interface IProps {
  height?: string | number
  message?: string
  isOnSearch?: boolean
  msgPosition?: 'top' | 'bottom'
  imgSize?: string
  containerStyles?: CSSProperties
  actionButton?: React.ReactNode
}

const EmptyResultView = ({
  height,
  message,
  isOnSearch,
  actionButton = null,
  msgPosition = 'top',
  containerStyles = { backgroundColor: 'transparent' },
  imgSize = '100px',
}: IProps) => {
  const { t } = useTranslation()

  const noDataMsg = (
    <Text fontSize="16px" color="gray5" fontWeight="bold" textAlign="center">
      {isOnSearch ? 'no_result_found_lbl' : t('no_data_available', { message: t(message ?? 'data').toLowerCase() })}
    </Text>
  )

  return (
    <EmptyResultWrapper height={height} style={{ ...containerStyles }}>
      <Box display="flex" alignItems="center" flexDirection="column" gap={'1rem'}>
        {msgPosition === 'top' && noDataMsg}
        {isOnSearch ? (
          <Suspense fallback={<Spinner fontSize={80} />}>
            <NoResultSearchImg height={imgSize} width={imgSize} />
          </Suspense>
        ) : (
          <Suspense fallback={<Spinner fontSize={80} />}>
            <NoResultImg height={imgSize} width={imgSize} />
          </Suspense>
        )}
        {msgPosition === 'bottom' && noDataMsg}
        {actionButton}
      </Box>
    </EmptyResultWrapper>
  )
}

const EmptyResultWrapper = styled.div<{ height?: string | number }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(p) => (p.height ? `height: ${typeof p.height === 'string' ? p.height : `${p.height}px`};` : ``)}
`

export default EmptyResultView
